import { handleApi } from "./api";
import { ApiGateWayEndPoint, definedRouteTypes, definedApiMethods } from ".";

export const getNceChanges = async ({ tenant }) => {
  const url = `${ApiGateWayEndPoint}/${definedRouteTypes.nce_changes}?tenant=${tenant}`;
  const resp = await handleApi(url, definedApiMethods.get);
  return resp;
};

export default getNceChanges;
